import React, { useState } from 'react'
import { Button, Card } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import sImg from '../../assets/shooter.png'
const Shooter = () =>{
    const [modal,SetModal] = useState(false);
    const OpenCLoseModal = ()=>{
        SetModal(!modal);
    }

    return(
        <>
            <Card className = "shadow">
                <div className  = "img-animation">
                    <Card.Img variant="top" src = {sImg}  />
                </div>
                <Card.Body>
                    <Card.Title>Shooter Game!</Card.Title>
                    <Card.Text>
                    Destruye tantos asteroides como puedas 
                    </Card.Text>
                    <Button onClick = {()=>OpenCLoseModal()} className = "btn custom-btn">
                        Jugar
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </Button>
                </Card.Body>
            </Card>
            <Modal 
                show = {modal}
                onHide = {()=>OpenCLoseModal()}>
                <Modal.Header closeButton>Shooter Game!</Modal.Header>
                <Modal.Body className = "text-center">

                    <div id="bloque_juego">
                        <iframe width ="430"  height = "570" src = "https://llfreedll.github.io/ShooterGame/">
                            
                        </iframe>
                    </div>

                </Modal.Body>
                    <Modal.Footer>
                        <button onClick = {()=>OpenCLoseModal()} className="btn btn-danger">Cerrar</button>
                    </Modal.Footer>
            </Modal>
        </>
    )

}
export default Shooter